module.exports = __webpack_public_path__ + "img/竹内公辅.de343365.png";